// extracted by mini-css-extract-plugin
export var dropdown = "_o2-1";
export var hidden = "_o2-0";